import React, { useState } from 'react';
import styles from './SelectPaymentMethodModal.module.scss';
import InteracIcon from '../../../assets/images/interac-icon.svg';
import CardIcon from '../../../assets/images/card-payment-icon.svg';
import Modal from '../../../components/Modal';
import InteracPaymentPreviewModal from '../InteracPaymentPreviewModal';
import ChevronRightIcon from '../../../assets/svg_components/ChevronRightIcon';

const paymentMethods = [
  { id: 'interac', icon: InteracIcon, name: 'Pay via Interac', action: 'interacDetails' },
  {
    id: 'card',
    icon: CardIcon,
    name: 'Pay via Card',
    action: 'chimoneyWidget',
    arrowRight: <ChevronRightIcon width="30" height="30" fillColor="#000" />
  }
];

interface ISelectPaymentMethodModal {
  onCardSelect: any;
  onClickAway: any;
  interacId: number;
  amount: number;
  transactionId: string;
  onSuccess: any;
  onClose: any;
}

const SelectPaymentMethodModal = ({
  onCardSelect,
  onClickAway,
  onClose,
  interacId,
  onSuccess,
  amount,
  transactionId
}: ISelectPaymentMethodModal) => {
  const [isInteracModalVisible, setIsInteracModalVisible] = useState(false);

  const handlePaymentMethodClick = (action: any) => {
    if (action === 'chimoneyWidget') {
      onCardSelect();
    } else if (action === 'interacDetails') {
      setIsInteracModalVisible(true);
    }
  };

  if (isInteracModalVisible) {
    return (
      <InteracPaymentPreviewModal
        onBack={() => setIsInteracModalVisible(false)}
        onClickAway={() => {}}
        interacId={interacId}
        amount={amount}
        transactionId={transactionId}
        onSuccess={onSuccess}
        onClose={onClose}
      />
    );
  }

  return (
    <Modal
      isShow
      isShowBackButton={false}
      onClose={onClose}
      isShowCloseIcon
      onClickAway={onClickAway}
      onBack={() => {}}
      className={styles.paymentMethodModal}
      contentClassName={styles.paymentMethodModal__content}
      isShowBottomLogo={false}>
      <h4 className={styles.paymentMethodModal__headText}>Select Payment Method</h4>
      <div className={styles.paymentMethodModal__paymentOptions}>
        {paymentMethods.map(({ id, name, action, icon, arrowRight }) => (
          <div
            key={id}
            className={styles.paymentMethodModal__option}
            onClick={() => handlePaymentMethodClick(action)}>
            <div className={styles.paymentMethodModal__iconAndPaymentType}>
              <img src={icon} alt={`${name} icon`} className={styles.paymentMethodModal__icon} />
              <span className={styles.paymentMethodModal__paymentType}>{name}</span>
            </div>
            <div className={styles.paymentMethodModal__arrowRight}>{arrowRight && arrowRight}</div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default SelectPaymentMethodModal;
